/**
 * Thin logging seam. Exists so that (a) `no-console` can stay on everywhere
 * else, and (b) stage 2 can route to a real sink without touching call sites.
 *
 * Deliberately never logs file contents or property values — an IFC may carry
 * client-confidential data and this app is a viewer, not a telemetry channel.
 */

const PREFIX = "[barform]";

export interface Logger {
  info(message: string, context?: Record<string, string | number | boolean>): void;
  warn(message: string, context?: Record<string, string | number | boolean>): void;
  error(message: string, cause?: unknown): void;
}

function format(message: string, context?: Record<string, string | number | boolean>): string {
  if (context === undefined) return `${PREFIX} ${message}`;
  const pairs = Object.entries(context)
    .map(([key, value]) => `${key}=${String(value)}`)
    .join(" ");
  return `${PREFIX} ${message} ${pairs}`;
}

export const logger: Logger = {
  info(message, context) {
    console.info(format(message, context));
  },
  warn(message, context) {
    console.warn(format(message, context));
  },
  error(message, cause) {
    console.error(format(message), cause ?? "");
  },
};
